import { InjectionToken } from '@angular/core';

export type FeedbackLocationAssigner = (url: string) => void;

export const FEEDBACK_LOCATION_ASSIGNER = new InjectionToken<FeedbackLocationAssigner>(
  'FEEDBACK_LOCATION_ASSIGNER',
  {
    providedIn: 'root',
    factory: () => (url: string) => window.location.assign(url),
  }
);
